var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveusericon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28L33.5 33M33.5 28L28.5 33M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M24 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveusericon4);
export default __webpack_public_path__ + "static/media/removeusericon-4.563b403bbc37fe69287301076f4600b6.svg";
export { ForwardRef as ReactComponent };